import styled from 'styled-components';

export const RedUnderlinedText = styled.span`
  color: ${({ theme }) => theme.palette.error} !important;
  border-color: ${({ theme }) => theme.palette.error} !important;
  font-weight: ${(props) => props.theme.fontWeightBold} !important;
  text-decoration: underline;
`;
